import useAct from 'DesktopCaller/useAct'

export default function NoMoreCalls({ organisation = null} ) {
  const act = useAct()

  return <div className={`box`}>
    <div className='part'>
      <div className='type'><h2 className='no-margin-top'>{ i18n.t('user.campaigns.phone.no_more_calls') }</h2></div>
      <div className='content'>
        <p>{ organisation ? i18n.t('user.campaigns.phone.no_more_calls_desc_organisation', { organisation: organisation?.name }) : i18n.t('user.campaigns.phone.no_more_calls_desc') }</p>
        <div className='buttons'>
          <button className="button red primary small" onClick={() => act.desktopCaller.disconnect()}>
            <SvgIconsCallerHangUp />{' '}
            <span>{i18n.t('user.campaigns.phone.disconnect')}</span>
          </button>
        </div>        
      </div>
    </div>
  </div>
}
